export default (): { label: string; value: string }[] => [
  { label: '300', value: '300' },
  { label: 'ADA', value: 'ada' },
  { label: 'Asylum', value: 'asylum' },
  { label: 'ATCO', value: 'atco' },
  { label: 'Atlantic', value: 'atlantic' },
  { label: 'Big Beat', value: 'bigBeat' },
  { label: 'Canvasback', value: 'canvasback' },
  { label: 'East West', value: 'eastWest' },
  { label: 'Elektra', value: 'elektra' },
  { label: 'Erato', value: 'erato' },
  { label: 'ffrr', value: 'ffrr' },
  { label: 'Fueled By Ramen', value: 'fueledByRamen' },
  { label: 'Nonesuch', value: 'nonesuch' },
  { label: 'Parlophone', value: 'parlophone' },
  { label: 'Reprise Records', value: 'repriseRecords' },
  { label: 'Rhino', value: 'rhino' },
  { label: 'Roadrunner', value: 'roadrunner' },
  { label: 'SIRE', value: 'sire' },
  { label: 'Spinnin Records', value: 'spinninRecords' },
  { label: 'Warner Classics', value: 'warnerClassics' },
  { label: 'Warner Music Nashville', value: 'warnerMusicNashville' },
  { label: 'Warner Records', value: 'warnerRecords' },
  { label: 'Other Label', value: 'otherLabel' },
  { label: 'No Label', value: 'noLabel' },
];
